import "./Form.scss";
import Icon from "@mdi/react";
import { mdiArrowRight } from "@mdi/js";
import { useSelector } from "react-redux";
import { sendMailToCompany, sendMailToCustomer } from "reducer";
import { useState, useEffect } from "react";
import { getCode } from "utils/encodeDecode";
import { Link } from "react-router-dom";

const formInputs = [
  { type: "email", name: "email", required: true, extended: true },
  { type: "text", name: "name", required: true },
  { type: "text", name: "surname", required: true },
  { type: "text", name: "company", required: true },
  { type: "phone", name: "phone" },
  { type: "text", name: "city" },
  { type: "text", name: "country", required: true },
];

const Form = ({ location, history }) => {
  const base64 = location?.state?.base64;
  const allResultsBase64 = location?.state?.allResultsBase64;
  const catalogue = location?.state?.catalogue;
  const description = location?.state?.product?.description;
  const name = location?.state?.product?.name;
  const circles = useSelector(({ circles }) => circles);
  const [form, setForm] = useState({
    message: `Please send more info about ${name}`,
  });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!location.state) {
      // redirect to home
      history.push("/");
    }
  }, [history, location.state]);

  const submitRequest = async () => {
    setSent(false);
    setError(false);
    setLoading(true);

    const result1 = await sendMailToCompany(
      form,
      Object.values(allResultsBase64).flat(2),
      description,
      catalogue,
      base64,
      getCode(circles)
    );
    const result2 = await sendMailToCustomer(form, base64, description);

    if (result1 === 200 && result2 === 200) {
      setSent(true);
      setLoading(false);
    } else {
      setError(true);
      setLoading(false);
    }
  };

  const handleChange = ({ target }) => {
    const value = target.type === "checkbox" ? target.checked : target.value;
    setForm({ ...form, [target.name]: value });
  };

  const isDisabled = () => {
    const requiredInputs = formInputs.filter((input) => input.required);
    const inputStatus = requiredInputs.map(
      (input) => !!form[input.name] && form[input.name] !== ""
    );
    const inputAreValid = inputStatus.every((input) => !!input);
    const privacyIsSet = form.privacy;
    return !inputAreValid || !privacyIsSet;
  };

  return (
    <div className="form-view">
      <div className="form-container container">
        <div className="form-title-wrapper">
          <p className="form-title">Requesting information for</p>
          <p className="form-title form-title--product">{name}</p>
        </div>
        {!!sent ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              minHeight: "60vh",
              fontSize: 20,
              gap: 24,
            }}
          >
            <div>Congratulation!</div>
            <div>Your request has been successfully sent</div>
            <div>You will be contacted by our team in the next few days</div>
            <Link className="btn table primary" to="/" style={{ marginTop: 16 }}>
              Homepage
            </Link>
          </div>
        ) : (
          <div className="form__wrapper">
            {formInputs.map((input, i) => (
              <input
                key={`${i}_${input.name}`}
                className={!!input.extended && "extended"}
                type={input.type}
                name={input.name}
                placeholder={!!input.required ? `${input.name}*` : input.name}
                onChange={handleChange}
              />
            ))}

            <div className="textarea-box extended">
              <label htmlFor="text-area">message</label>
              <textarea
                id="text-area"
                name="message"
                defaultValue={form.message}
                onChange={handleChange}
              />
            </div>

            <div className="checkbox-box extended">
              <div className="checkbox">
                <input
                  id="privacy"
                  type="checkbox"
                  name="privacy"
                  onChange={handleChange}
                />

                <label htmlFor="privacy">
                  <p>
                    I Agree to{" "}
                    <a
                      href="https://www.stucchigroup.com/privacy-policy/"
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#e6007e", textDecoration: "underline" }}
                    >
                      {" "}
                      Privacy Policy
                    </a>{" "}
                    <sup>(required)</sup>
                  </p>
                </label>
              </div>

              <div className="checkbox">
                <input
                  id="comunications"
                  type="checkbox"
                  name="comunications"
                  onChange={handleChange}
                />

                <label htmlFor="comunications">
                  I Agree to receive Marketing comunications
                </label>
              </div>
            </div>

            <div className="button-container extended">
              <button
                type="button"
                className="btn table primary"
                onClick={submitRequest}
                disabled={isDisabled() || loading}
              >
                {loading ? (
                  <div className="loader"></div>
                ) : (
                  "Send"
                )}
              </button>
            </div>
          </div>
        )}

        {!sent && (
          <div style={{ textAlign: "center", marginTop: "2rem" }}>
            {error && (
              <div style={{ color: "red" }}>
                An error occured while sending the email
              </div>
            )}

            <div className="form-footer" style={{ marginTop: "2rem" }}>
              A copy of the request will be sent to your email address.
            </div>

            <div className="form-footer__back">
              <Back goBack={history.goBack} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Form;

const Back = ({ goBack }) => (
  <div className="form__back" onClick={goBack}>
    <span>Back</span>
    <Icon path={mdiArrowRight} size={1} />
  </div>
);
